var _style, _path, _path2, _path3, _path4, _g, _line, _line2, _line3, _line4, _line5;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgAdminExpense(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Layer_1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    x: "0px",
    y: "0px",
    viewBox: "0 0 600 600",
    style: {
      enableBackground: "new 0 0 600 600"
    },
    xmlSpace: "preserve",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _style || (_style = /*#__PURE__*/React.createElement("style", {
    type: "text/css"
  }, "\r\n\t.st0{fill:none;stroke:#000000;stroke-width:15;stroke-linecap:round;stroke-miterlimit:10;}\r\n")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M141.6,536.6c0-10.5,0-20.7,0-30.9c0-8-0.7-16.1,0.1-24.1c4-41.4,0.8-82.9,1.7-124.4c0.1-5.8,0.9-6.3,8.2-6.3 c49.8,0,99.7,0,149.5,0c48,0,96.1,0,144.1,0c8.5,0,8.7,0.3,8.7,8.9c0,39.2,0.1,78.4,0.1,117.5c0,18.3-0.2,36.6-0.4,54.8 c0,1.4-0.2,2.7-0.4,4.4C349.5,536.6,245.9,536.6,141.6,536.6z"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M298.8,292.1c67,0,133.9,0,200.9,0c8.1,0,12.6,4.5,12.7,12.6c0,7,0.1,14.1,0,21.1c-0.1,7.8-4.7,12.3-12.4,12.6 c-1.6,0.1-3.2,0-4.8,0c-130.5,0-261,0-391.6,0c-2.4,0-4.8,0.1-7.2-0.1c-6.4-0.5-10.9-4.9-11.1-11.3c-0.2-8-0.2-16.1,0-24.1 c0.2-6.5,5.4-10.8,12.7-10.8c27.9,0,55.9,0,83.8,0C220.8,292.1,259.8,292.1,298.8,292.1z"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M298.5,279.7c-23.7,0-47.4,0-71.1,0c-7.6,0-8.5-0.8-5.8-8c4.7-12.3,11.1-23.2,25.4-26.6c5.3-1.3,7.2-6.3,7.7-10.6 c1-9.3,2.2-18.9,1-28.1c-2-15.6-2-30.7,2.6-45.8c4.1-13.5,12.9-23.3,26-26c14.3-2.9,29.8-4.3,42.4,6.9c9.6,8.6,13.3,20,15.7,32.4 c3.1,16-2.4,31.5-1.3,47.3c0.3,4.6,1,9.1,2,13.6c1.3,6.1,4.5,10.1,11.3,11.6c6.9,1.5,11.8,6.9,15.3,12.8c2.8,4.6,5,9.6,6.8,14.7 c1.7,4.6,0.6,5.7-4.4,5.8c-6.4,0.1-12.9,0-19.3,0C334.7,279.6,316.6,279.6,298.5,279.7C298.5,279.7,298.5,279.7,298.5,279.7z  M299.9,236c8.5-0.9,15.2-5.8,20.1-12.6c5.2-7.3,9.7-15.2,14.2-22.9c1.1-1.8,1.5-4.2,1.6-6.3c0.2-3.1-1.1-4.7-4.8-4.2 c-2.1,0.3-4.7-0.2-6.7-1.2c-12.4-6.1-24.7-12.5-37.1-18.6c-6.8-3.4-11.9-2.1-16.2,4.2c-1.8,2.6-2.8,5.7-4.1,8.6 c-0.8,1.8-1.3,3.8-2.5,5.4c-3.4,4.9-3.1,11.4,0.4,16c3.4,4.4,6.4,9.1,9.3,13.8C280,228,287.5,235.2,299.9,236z M299.5,258.4 c9.1-0.7,18.6-3.8,26.2-11.5c0.9-0.9,2.2-2.9,1.8-3.5c-1.9-3-4-6-6.7-8.2c-1-0.8-4.1,0.4-5.8,1.4c-12.1,7.9-20.8,7.9-33.3-0.6 c-2.4-1.7-4.6-2.5-6.5,0.7c-0.6,1-1.5,1.9-2.4,2.7c-3.9,3.9-3.9,4.8,0.1,8.6C280,254.7,288.5,257.7,299.5,258.4z"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M451.4,63.4c32.8-1.1,65.1,27.7,63.4,66.6c-1.4,33.8-28.5,62.3-64.5,61.9c-36.5-0.5-62.7-28.7-63.4-64.1 C386.1,90.9,418.3,61.5,451.4,63.4z M500,127.6c1-28.2-22.4-50.7-49.2-50.1c-24.8,0.5-52,19.1-48.9,54.6 c2.1,23.9,19.1,43.2,46.7,45.1C476.8,179.2,501.5,154.2,500,127.6z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", null, /*#__PURE__*/React.createElement("path", {
    d: "M415.8,108.4c13.6,5.3,26.1,12.8,38.3,20.7c0,0-5.3,0.7-5.3,0.7c9.1-10.6,18.7-20.9,29.7-29.6c2.6-2,2.6-2.3,0.9,0.8 c-3.2,5.7-6.9,11.2-10.7,16.5c-5,7-10.5,13.7-16.1,20.2c0,0-2.9-2-2.9-2C437.6,127.6,425.9,118.9,415.8,108.4L415.8,108.4z"
  }))), _line || (_line = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 118.2,
    y1: 240.1,
    x2: 179.4,
    y2: 240.1
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 118.2,
    y1: 265.1,
    x2: 179.4,
    y2: 265.1
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 118.2,
    y1: 215.1,
    x2: 179.4,
    y2: 215.1
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 420.3,
    y1: 240.1,
    x2: 481.5,
    y2: 240.1
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    className: "st0",
    x1: 420.3,
    y1: 265.1,
    x2: 481.5,
    y2: 265.1
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgAdminExpense);
export default __webpack_public_path__ + "static/media/admin_expense.4a338a7fa3ecdced262d87ae54a4906a.svg";
export { ForwardRef as ReactComponent };